import React from 'react';
import { Link } from 'react-router-dom';
import "../components/Form.css"

const Form = () => {
    return (
        <div className='form'>
            <form action="">
                <label>Your Name</label>
                <input type="text" />

                <label>Your Email</label>
                <input type="email" />

                <label>Subjact</label>
                <input type="text" />

                <label>Details</label>
                <textarea row="8" placeholder='Type Your Message Here' />
                <Link to='/' className='btn'>Submit</Link>
            </form>
            
        </div>
    );
}

export default Form;
